const checkStackList = (stack) => {
  // eslint-disable-next-line no-unused-vars
  let currentStack;
  switch (stack) {
    case 'ocean':
      currentStack = 'blue';
      break;
    case 'blueocean':
      currentStack = 'blue';
      break;
    case 'cci':
      currentStack = 'cci';
      break;
    case 'algida':
      currentStack = 'algida';
      break;
    case 'unilever':
      currentStack = 'algida';
      break;
    case 'shelfsight':
      currentStack = 'shelfsight';
      break;
    case 'demo':
      currentStack = 'shelfsight';
      break;
    default:
      currentStack = stack;
  }

  return currentStack;
};

export default () => checkStackList(window.location.hostname.split('.')[0]);
